import { Headset, TelecomEthernet, Telephony } from '../assets-icon-svg/icons';

const telecomIcons = {
  TelecomEthernet,
  Telephony,
  Headset,
};

export default telecomIcons;
